import React from 'react';
import {Table} from '../../../components/table/Table';
import {useInvoke} from '../../../controllers/useInvoke';

const TITLE = {
  field: 'page_title',
  header: 'Web Page Title',
  responsive: 'sm',
};

const URL = {
  field: 'page_url',
  header: 'URL',
};

const DESCRIPTION = {
  field: 'page_content',
  header: 'Description',
};

const CREATEDON = {
  type: 'date',
  field: 'created_on',
  header: 'Created On',
};

const COMPLETEDON = {
  type: 'date',
  field: 'completed_date',
  header: 'Completed On',
};

const STATUS = {
  field: 'status',
  header: 'Status',
};

export const WebPageActiveTable = props => {
  const {
    route: {params},
    navigation,
    searchValue,
  } = props;
  const {communicationFilter} = params;
  const invoke = useInvoke({method: 'put'});
  const markComplete = ({row}) => {
    invoke({
      uri: `/webpages/${row?._id}`,
      props: {
        status: 'completed',
        completed_date: new Date(),
      },
    });
  };
  return (
    <Table
      search={searchValue}
      searchFields={'page_title'}
      api={`/web-page-communication`}
      addOnFilter={{
        status: 'active',
        ...communicationFilter,
      }}
      params={params}
      onRowPress={row => {
        navigation.navigate('edit-web-page', row);
      }}
      columns={[
        TITLE,
        URL,
        DESCRIPTION,
        CREATEDON,
        STATUS,
      ]}
      moreActions={[
        {
          title: 'Mark Completed',
          onPress: markComplete,
        },
      ]}
    />
  );
};

export const WebPageCompletedTable = ({route: {params}, searchValue}) => {
  const {communicationFilter} = params;
  return (
    <Table
      search={searchValue}
      searchFields={'page_title'}
      api={`/web-page-communication`}
      addOnFilter={{
        status: 'completed',
        ...communicationFilter,
      }}
      params={params}
      columns={[TITLE, URL, DESCRIPTION, CREATEDON, STATUS, COMPLETEDON]}
    />
  );
};
